import React from 'react';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { map } from 'lodash';
import { Select } from 'semantic-ui-react';

const GET_SERVICE_GROUPS_QUERY = gql`
    query getServiceGroups($salon: ID!, $lang: String!) {
        viewer {
            id
            ... on Administrator {
                salon(id: $salon) {
                    id
                    serviceGroups {
                        nodes {
                            id
                            name(lang: $lang)
                        }
                    }
                }
            }
        }
    }
`;

function ServiceGroupSelect({ meta, dispatch, ...props }) {
    const salon = useSelector(({ user }) => user.get('salon'));
    const currentLanguage = useSelector(
        ({ intl }) => intl.get('locale') || intl.get('defaultLanguage'),
    );

    const { data, loading } = useQuery(GET_SERVICE_GROUPS_QUERY, {
        variables: { salon, lang: currentLanguage },
        fetchPolicy: 'cache-and-network',
    });

    const nodes = !loading ? data?.viewer?.salon?.serviceGroups?.nodes ?? [] : [];
    const options = map(nodes, group => ({ value: group.id, text: group.name }));

    return <Select loading={loading} options={options} {...props} />;
}

export default ServiceGroupSelect;
